import { gql } from "@apollo/client"

export const GET_TERMS_AND_CONDITIONS = gql`
  query Query($getTermAndConditionsId: String!) {
    getTermAndConditions(id: $getTermAndConditionsId) {
      id
      title
      content
      checkbox
      created
      modified
    }
  }
`
